import React from "react";
import AllUomConversion from "./UomConversionModule/AllUomConversion";

const UomConversion = () => {
  return (
    <div>
      <AllUomConversion />
    </div>
  );
};

export default UomConversion;
